import React, { Suspense, useState } from 'react';

import ProductReviewsContext from 'Features/Product/context/product-reviews-context';
import useFetchProduct from 'Hooks/useFetchProduct';
import SmallUspBar from 'Components/Usp/SmallUspBar';
import RenderProductState from 'Components/Utility/Product/RenderProductState';
import ProductView from 'Features/Product/components/Views/ProductView';
import GiftCardView from 'Features/Product/components/Views/GiftCardView';
import VisibleVoucher from 'Components/Vouchers/VisibleVoucher';

const ProductPage = ({ match = {}, isPreview }) => {
  const slug = match?.params?.slug;
  const id = match?.params?.id;
  const type = match?.params?.type;

  const {
    product,
    urlRedirect,
    redirect,
    notFound,
    isLoading,
  } = useFetchProduct({ slug, id, type, isPreview });

  const [reviews, setReviews] = useState([]);

  const reviewContext = { reviews, setReviews }; // Allow reviews to be updated from down the tree

  const renderState = RenderProductState({
    urlRedirect,
    matchUrl: match.url,
    redirect,
    notFound,
    isLoading,
    product,
  });

  if (renderState) return renderState;

  const componentToLoad = product?.display_type === 'gift-card' ? 'gift-card' : 'product';

  return (
    <ProductReviewsContext.Provider value={reviewContext}>
      <SmallUspBar product={product} />
      <VisibleVoucher product={product} />

      {(componentToLoad === 'product') &&
        <Suspense>
          <ProductView product={product} />
        </Suspense>
      }

      {componentToLoad === 'gift-card' &&
        <Suspense>
          <GiftCardView product={product} />
        </Suspense>
      }

    </ProductReviewsContext.Provider >
  );
};

export default ProductPage;
